import React from 'react';
import { IProps } from '../../domain/model';
import UserPaymentUpload from '../../components/admin/upload/userPaymentUpload';

export default function userPaymentUploadPage({ state }: IProps): JSX.Element {
  return (
    <>
      {!state.loading && (
        <>
          <UserPaymentUpload />
        </>
      )}
    </>
  );
}
